import { Add, DateRange, Delete, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Divider, Grid, IconButton, InputAdornment, List, ListItem, ListItemSecondaryAction, ListItemText, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import $carbon, { pesticideTypes } from "../../../services/$carbon";
import SelectInput from "../../ui/SelectInput";
import { variables } from "../../../styles/abstract/variables";
import { electricityEU, formatEngineLoads, formatFuelTypes, formatFuels, formatMotorPower, formatOperationCategories, formatOperations, motorPower, operations } from "./FuelFactors";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";

function FuelForm(props) {
  const mount = useRef();
  const { model, setModel, nextStep, prevStep, climateZone, area, year } = props;

  const [localDirect, setLocalDirect] = useState({
    source: undefined,
    fuel: undefined,
    amount: undefined,
  });

  const [localEstimated, setLocalEstimated] = useState({
    source: undefined,
    fuel: undefined,
    isOperation: true,
    operationCategory: undefined,
    operation: undefined,
    numberOfBales: undefined,

    enginePower: undefined,
    engineLoad: undefined,
    engineConsumption: undefined,
    hours: undefined,

    transportLength: undefined,
    transportMass: undefined
  })

  useEffect(() => {
    setTimeout(() => {
      mount.current = true;
    }, 500)
  }, [])

  useEffect(() => {
    if (!mount.current) return;
    setModel({
      estimated: []
    })
  }, [localEstimated.isOperation])

  useEffect(() => {

    if (model.isDirect) {
      if (model.direct.length > 0) {
        let total = $carbon.calculateFuelEmission(model.direct, model.estimated, model.isDirect, area);
        console.log(total);
        setModel({ totalEmission: total });
      } else {
        setModel({ totalEmission: undefined });
      }
    } else {
      if (model.estimated.length > 0) {
        let total = $carbon.calculateFuelEmission(model.direct, model.estimated, model.isDirect, area);
        console.log(total);
        setModel({ totalEmission: total });
      } else {
        setModel({ totalEmission: undefined });
      }
    }
  }, [model.isDirect, JSON.stringify(model.direct), JSON.stringify(model.estimated)]);

  const onChangeSource = (e) => {
    if (e.target.value === 'Electricity') {
      setLocalDirect(current => ({ ...current, source: e.target.value, fuel: { unit: 'kWh', ef: electricityEU } }));
      return;
    }
    setLocalDirect(current => ({ ...current, source: e.target.value, fuel: undefined }));
  }

  const onChangeEstimatedSource = (e) => {
    if (e.target.value === 'Electricity') {
      setLocalEstimated(current => ({ ...current, source: e.target.value, fuel: { unit: 'kWh', ef: electricityEU } }));
      return;
    }
    setLocalEstimated(current => ({ ...current, source: e.target.value, fuel: undefined }));
  }

  const onChangeOperationCategory = (e) => {
    setLocalEstimated(current => ({ ...current, operationCategory: e.target.value, operation: undefined, consumption: undefined }));
  }

  const isEstimatedDisabled = () => {
    if (localEstimated.isOperation) {
      return !Boolean(localEstimated.operationCategory) ||
        !Boolean(localEstimated.operation) ||
        (localEstimated.operationCategory === 'Root crop harvesting' && !Boolean(localEstimated.numberOfBales)) ||
        !Boolean(localEstimated.source) ||
        !Boolean(localEstimated.fuel);
    } else {
      return !Boolean(localEstimated.engineConsumption) || !Boolean(localEstimated.enginePower) || !Boolean(localEstimated.engineLoad) || !Boolean(localEstimated.hours) || !Boolean(localEstimated.source) || !Boolean(localEstimated.fuel) || !Boolean(localEstimated.hours);
    }
  }

  const renderForm = () => {
    if (model.isDirect) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <SelectInput name="Source" value={localDirect.source} items={formatFuelTypes()} onChange={onChangeSource} label="Source" variant="outlined" fullWidth size="small" />
          </Grid>
          {localDirect.source !== 'Electricity' && <Grid item xs={12} sm={6}>
            <SelectInput name="Fuel" value={localDirect.fuel} items={formatFuels(localDirect.source)} onChange={(e) => { setLocalDirect(current => ({ ...current, fuel: e.target.value })) }} label="Fuel" variant="outlined" fullWidth size="small" />
          </Grid>}
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localDirect.amount} onChange={(e) => setLocalDirect(current => ({ ...current, amount: e.target.value }))} type="number" label={`Amount of fuel/energy ${localDirect.fuel?.unit || ''}`} variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Button disabled={!Boolean(localDirect.source) || !Boolean(localDirect.fuel) || !Boolean(localDirect.amount)} variant="contained" onClick={() => {
              setModel({
                direct: [...model.direct, {
                  source: localDirect.source,
                  fuel: localDirect.fuel,
                  amount: localDirect.amount,
                }]
              });
            }} startIcon={<Add />}>Add record</Button>
          </Grid>
        </>
      )
    }

    return (
      <>
        <Grid item xs={12} textAlign="left">
          <ButtonGroup orientation="horizontal">
            <Button variant={localEstimated.isOperation ? 'contained' : 'outlined'} onClick={() => setLocalEstimated(current => ({ ...current, isOperation: true }))}>Per Operation</Button>
            <Button variant={!localEstimated.isOperation ? 'contained' : 'outlined'} onClick={() => setLocalEstimated(current => ({ ...current, isOperation: false }))}>Per Machine Usage</Button>
          </ButtonGroup>
        </Grid>
        <Grid item xs={12}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <MobileDatePicker
              format="YYYY-MM-DD"
              minDate={moment(`${year}-01-01`)}
              maxDate={moment(`${year}-12-31`)}
              slotProps={{
                textField: {
                  label: 'Date',
                  variant: 'outlined',
                  fullWidth: true,
                  size: 'small',
                  InputProps: { endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer', mb: '3px' }}><DateRange fontSize="small" /></InputAdornment> }
                }
              }}
              value={localEstimated.date}
              onChange={(newValue) => setLocalEstimated(current => ({...current, date: newValue.format('YYYY-MM-DD') }))} />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput name="Source" value={localEstimated.source} items={formatFuelTypes()} onChange={onChangeEstimatedSource} label="Source" variant="outlined" fullWidth size="small" />
        </Grid>
        {localEstimated.source !== 'Electricity' && <Grid item xs={12} sm={6}>
          <SelectInput name="Fuel" value={localEstimated.fuel} items={formatFuels(localEstimated.source)} onChange={(e) => { setLocalEstimated(current => ({ ...current, fuel: e.target.value })) }} label="Fuel" variant="outlined" fullWidth size="small" />
        </Grid>}
        {localEstimated.isOperation && <>

          <Grid item xs={12} sm={6}>
            <SelectInput name="Category" value={localEstimated.operationCategory} items={formatOperationCategories()} onChange={onChangeOperationCategory} label="Category" variant="outlined" fullWidth size="small" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectInput name="Operation" value={localEstimated.operation} items={formatOperations(localEstimated.operationCategory)} onChange={(e) => setLocalEstimated(current => ({ ...current, operation: e.target.value, consumption: operations[localEstimated.operationCategory][e.target.value] }))} label="Operation" variant="outlined" fullWidth size="small" />
          </Grid>
          {localEstimated.operationCategory === 'Root crop harvesting' && <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.numberOfBales} onChange={(e) => setLocalEstimated(current => ({ ...current, numberOfBales: e.target.value }))} type="number" label="Number of bales" variant="outlined" fullWidth />
          </Grid>}
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.transportLength} onChange={(e) => setLocalEstimated(current => ({ ...current, transportLength: e.target.value }))} type="number" label="Transport distance [km]" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.transportMass} onChange={(e) => setLocalEstimated(current => ({ ...current, transportMass: e.target.value }))} type="number" label="Payload mass [kg]" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Button disabled={isEstimatedDisabled()} variant="contained" onClick={() => {
              setModel({
                estimated: [...model.estimated, {
                  source: localEstimated.source,
                  fuel: localEstimated.fuel,
                  isOperation: true,
                  operationCategory: localEstimated.operationCategory,
                  operation: localEstimated.operation,
                  numberOfBales: localEstimated.numberOfBales,
                  transportLength: localEstimated.transportLength,
                  transportMass: localEstimated.transportMass,
                  consumption: localEstimated.consumption
                }]
              })
            }} startIcon={<Add />}>Add record</Button>
          </Grid>
        </>}

        {!localEstimated.isOperation && <>
          <Grid item xs={12} sm={6}>
            <SelectInput name="Engine Power [kW]/[HP]" value={localEstimated.enginePower} items={formatMotorPower()} onChange={(e) => { setLocalEstimated(current => ({ ...current, enginePower: e.target.value, engineLoad: undefined, engineConsumption: undefined })) }} label="Engine Power [kW]/[HP]" variant="outlined" fullWidth size="small" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectInput name="Engine Load" value={localEstimated.engineLoad} items={formatEngineLoads(localEstimated.enginePower)} onChange={(e) => setLocalEstimated(current => ({ ...current, engineLoad: e.target.value, engineConsumption: motorPower[localEstimated.enginePower][e.target.value] }))} label="Engine Load" variant="outlined" fullWidth size="small" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.hours} onChange={(e) => setLocalEstimated(current => ({ ...current, hours: e.target.value }))} type="number" label="Total hours on the field" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.transportLength} onChange={(e) => setLocalEstimated(current => ({ ...current, transportLength: e.target.value }))} type="number" label="Transport distnce [km]" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField size="small" value={localEstimated.transportMass} onChange={(e) => setLocalEstimated(current => ({ ...current, transportMass: e.target.value }))} type="number" label="Load mass [kg]" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Button disabled={isEstimatedDisabled()} variant="contained" onClick={() => {
              setModel({
                estimated: [...model.estimated, {
                  source: localEstimated.source,
                  fuel: localEstimated.fuel,
                  isOperation: false,
                  enginePower: localEstimated.enginePower,
                  engineLoad: localEstimated.engineLoad,
                  engineConsumption: localEstimated.engineConsumption,
                  transportLength: localEstimated.transportLength,
                  transportMass: localEstimated.transportMass,
                  hours: localEstimated.hours
                }]
              })
            }} startIcon={<Add />}>Add record</Button>
          </Grid>
        </>}



      </>
    )
  }

  const transportConsumption = (record) => {

    if (record.transportLength && record.transportMass) {
      return parseFloat(record.transportLength) * (parseFloat(record.transportMass) / 1000) * 0.09; // Example calculation, adjust as needed
    }

    return 0;
  }

  const estimatedConsumption = (area, record) => {
    if (record.isOperation) {
      if (record.operationCategory === 'Root crop harvesting') {
        return `${(record.consumption * record.numberOfBales + transportConsumption(record)).toFixed(0)} [L]`
      }
      return `${(record.consumption * area + transportConsumption(record)).toFixed(0)} [L]`
    }
  }

  const renderRecords = () => {
    if (model[model.isDirect ? 'direct' : 'estimated'].length === 0) {
      return (
        <Grid item xs={12}>
          <Typography>No records</Typography>
        </Grid>
      )
    }

    if (model.isDirect) {

      return (
        <Grid item xs={12}>
          <List dense>
            {
              model.direct.map((record, i) => (
                <ListItem className="co-background" key={i}>
                  <ListItemText primary={`${record.source} ${record.source !== 'Electricity' ? ` - ${record.fuel.name}` : ''}`} secondary={`Amount of fuel/energy: ${record.amount} [${record.fuel.unit}]`} />
                  <ListItemSecondaryAction><IconButton onClick={() => setModel({ direct: model.direct.filter((r, j) => j !== i) })} size="small" color="error"><Delete fontSize="small" /></IconButton></ListItemSecondaryAction>
                </ListItem>
              ))
            }
          </List>
        </Grid>
      )
    }



    return (
      <Grid item xs={12}>
        <List dense>
          {
            model.estimated.map((record, i) => {

              if (record.isOperation) {
                return (
                  <ListItem className="co-background" key={i}>
                    <ListItemText primary={`${record.operationCategory} - ${record.operation}`} secondary={`Estimated fuel consumption: ${estimatedConsumption(area, record)}`} />
                    <ListItemSecondaryAction><IconButton onClick={() => setModel({ estimated: model.estimated.filter((r, j) => j !== i) })} size="small" color="error"><Delete fontSize="small" /></IconButton></ListItemSecondaryAction>
                  </ListItem>
                )
              }

              return (
                <ListItem className="co-background" key={i}>
                  <ListItemText primary={`Engine Power: ${record.enginePower} - Engine Load: ${record.engineLoad}`} secondary={`Estimated fuel consumption: ${(parseFloat(record.hours) * record.engineConsumption).toFixed(0)} [L]`} />
                  <ListItemSecondaryAction><IconButton onClick={() => setModel({ estimated: model.estimated.filter((r, j) => j !== i) })} size="small" color="error"><Delete fontSize="small" /></IconButton></ListItemSecondaryAction>
                </ListItem>
              )
            })
          }
        </List>
      </Grid>
    )
  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="center">
                <ButtonGroup orientation="horizontal">
                  <Button variant={model.isDirect ? 'contained' : 'outlined'} onClick={() => setModel({ isDirect: true })}>Direct</Button>
                  <Button variant={!model.isDirect ? 'contained' : 'outlined'} onClick={() => setModel({ isDirect: false })}>Estimated</Button>
                </ButtonGroup>
              </Grid>

              {renderForm()}

              <Grid item xs={12}>
                <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
              </Grid>

              {renderRecords()}

            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} variant="contained" endIcon={<KeyboardArrowRight />}>Next</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default FuelForm;